import AL from 'assets/images/hero/state-heroes/alabama.jpg';
import AK from 'assets/images/hero/state-heroes/alaska.jpg';
import AR from 'assets/images/hero/state-heroes/arkansas.jpg';
import AZ from 'assets/images/hero/state-heroes/arizona.jpg';
import CA from 'assets/images/hero/state-heroes/california.jpg';
import CO from 'assets/images/hero/state-heroes/colorado.jpg';
import CT from 'assets/images/hero/state-heroes/connecticut.jpg';
import DE from 'assets/images/hero/state-heroes/delaware.jpg';
import DC from 'assets/images/hero/state-heroes/district-of-columbia.jpg';
import FL from 'assets/images/hero/state-heroes/florida.jpg';
import GA from 'assets/images/hero/state-heroes/georgia.jpg';
import HI from 'assets/images/hero/state-heroes/hawaii.jpg';
import ID from 'assets/images/hero/state-heroes/idaho.jpg';
import IL from 'assets/images/hero/state-heroes/illinois.jpg';
import IN from 'assets/images/hero/state-heroes/indiana.jpg';
import IA from 'assets/images/hero/state-heroes/iowa.jpg';
import KS from 'assets/images/hero/state-heroes/kansas.jpg';
import KY from 'assets/images/hero/state-heroes/kentucky.jpg';
import LA from 'assets/images/hero/state-heroes/louisiana.jpg';
import ME from 'assets/images/hero/state-heroes/maine.jpg';
import MD from 'assets/images/hero/state-heroes/maryland.jpg';
import MA from 'assets/images/hero/state-heroes/massachusetts.jpg';
import MI from 'assets/images/hero/state-heroes/michigan.jpg';
import MN from 'assets/images/hero/state-heroes/minnesota.jpg';
import MS from 'assets/images/hero/state-heroes/mississippi.jpg';
import MO from 'assets/images/hero/state-heroes/missouri.jpg';
import MT from 'assets/images/hero/state-heroes/montana.jpg';
import NE from 'assets/images/hero/state-heroes/nebraska.jpg';
import NV from 'assets/images/hero/state-heroes/nevada.jpg';
import NH from 'assets/images/hero/state-heroes/new-hampshire.jpg';
import NJ from 'assets/images/hero/state-heroes/new-jersey.jpg';
import NM from 'assets/images/hero/state-heroes/new-mexico.jpg';
import NY from 'assets/images/hero/state-heroes/new-york.jpg';
import NC from 'assets/images/hero/state-heroes/north-carolina.jpg';
import ND from 'assets/images/hero/state-heroes/north-dakota.jpg';
import OH from 'assets/images/hero/state-heroes/ohio.jpg';
import OK from 'assets/images/hero/state-heroes/oklahoma.jpg';
import OR from 'assets/images/hero/state-heroes/oregon.jpg';
import PA from 'assets/images/hero/state-heroes/pennsylvania.jpg';
import RI from 'assets/images/hero/state-heroes/rhode-island.jpg';
import SC from 'assets/images/hero/state-heroes/south-carolina.jpg';
import SD from 'assets/images/hero/state-heroes/south-dakota.jpg';
import TN from 'assets/images/hero/state-heroes/tennessee.jpg';
import TX from 'assets/images/hero/state-heroes/texas.jpg';
import UT from 'assets/images/hero/state-heroes/utah.jpg';
import VT from 'assets/images/hero/state-heroes/vermont.jpg';
import VA from 'assets/images/hero/state-heroes/virginia.jpg';
import WA from 'assets/images/hero/state-heroes/washington.jpg';
import WV from 'assets/images/hero/state-heroes/west-virginia.jpg';
import WI from 'assets/images/hero/state-heroes/wisconsin.jpg';
import WY from 'assets/images/hero/state-heroes/wyoming.jpg';

export const STATE_HERO_IMAGES = {
	AL,
	AK,
	AZ,
	AR,
	CA,
	CO,
	CT,
	DE,
	DC,
	FL,
	GA,
	HI,
	ID,
	IL,
	IN,
	IA,
	KS,
	KY,
	LA,
	ME,
	MD,
	MA,
	MI,
	MN,
	MS,
	MO,
	MT,
	NE,
	NV,
	NH,
	NJ,
	NM,
	NY,
	NC,
	ND,
	OH,
	OK,
	OR,
	PA,
	RI,
	SC,
	SD,
	TN,
	TX,
	UT,
	VT,
	VA,
	WA,
	WV,
	WI,
	WY,
};
